import React from 'react';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { getPages } from "./app/Pages";
import { LicenseManager } from "@ag-grid-enterprise/core";
import { ModuleRegistry } from '@ag-grid-community/core';
import { AdvancedFilterModule } from "@ag-grid-enterprise/advanced-filter";
import { CsvExportModule } from '@ag-grid-community/csv-export';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { MenuModule } from '@ag-grid-enterprise/menu';
import ErrorBoundary from './ErrorBoundary';
import { useUserInfoQuery } from "./api/userApiSlice";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider as GlobusProvider,  } from '@globus/react-auth-context';
import ProtectedRoute from './components/ProtectedRoute';
import { LicenseManager as ChartsLicenseManager } from 'ag-charts-enterprise'

export const queryClient = new QueryClient()

const baseURL = window.location;
// @ts-ignore
const globusId = window.env.globusID;



function App(): JSX.Element {
    LicenseManager.setLicenseKey(window.env.agLicense);
    ChartsLicenseManager.setLicenseKey(window.env.agLicense);
    ModuleRegistry.registerModules([
        CsvExportModule,
        ExcelExportModule,
        AdvancedFilterModule,
        ClientSideRowModelModule,
        MenuModule,
        ColumnsToolPanelModule,
        FiltersToolPanelModule,
        SetFilterModule,
        ServerSideRowModelModule
    ]);
    const { isFetching: isUserDataLoading } = useUserInfoQuery({});
    if (isUserDataLoading) {
        return <div>Loading...</div>; //Wait until userData is loaded
    }
    const pages = getPages(false);

    const renderRoute = (route: any) => {
        const element = route?.public
            ? <route.element/>
            : <ProtectedRoute route={route}>
                <route.element/>
            </ProtectedRoute>
        switch (route.type) {
        case 'layout':
            return (
                <Route key={"layout"} element={<route.element/>}>
                    {route.children.map((child: any) => renderRoute(child))}
                </Route>
            );
        case 'path':
            return (
                <Route key={route.path} path={route.path} element={element}/>
            );
        case 'index':
            return (
                <Route key={"index"} index element={element}/>
            );
        case 'link':
            return;
        default:
            return;
        }
    };

    return (
        <GlobusProvider
            client={globusId}
            redirect={`${baseURL.protocol}//${baseURL.host}/globus-redirect`}
            scopes={'urn:globus:auth:scope:transfer.api.globus.org:all'}
            useRefreshTokens={true}
        >
            <QueryClientProvider client={queryClient}>
                <ErrorBoundary>
                    <Routes>
                        {pages.map((page: any) => renderRoute(page))}
                        <Route key="fallback-route" path="*" element={<Navigate to='/' replace />} />
                    </Routes>
                </ErrorBoundary>
            </QueryClientProvider>
        </GlobusProvider>

    );
}

export default App;
